import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getCreateWorldCupGroupStep1FormStyles = (theme: Theme) =>
  StyleSheet.create({
    root: { flexDirection: 'column', gap: 10 },
    sectionLabel: {
      fontSize: 9,
      fontWeight: '800',
      color: theme.primary,
      letterSpacing: 1.4,
      textTransform: 'uppercase',
      marginBottom: 6,
    },
    nameInputWrap: {
      borderRadius: 14,
      borderWidth: 1.5,
      borderColor: theme.gray[200],
      backgroundColor: theme.background.primary,
      paddingHorizontal: 14,
      paddingVertical: 12,
      flexDirection: 'row',
      alignItems: 'center',
    },
    nameInput: {
      flex: 1,
      fontSize: 16,
      fontWeight: '700',
      color: theme.gray[900],
    },
    charCountInline: {
      fontSize: 10,
      fontWeight: '700',
      color: theme.gray[400],
      flexShrink: 0,
      marginLeft: 8,
    },
    suggestionRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 6,
      marginTop: 4,
    },
    suggestionChip: {
      paddingHorizontal: 10,
      paddingVertical: 5,
      borderRadius: 99,
      backgroundColor: `${theme.primary}22` as never,
      borderWidth: 1,
      borderColor: `${theme.primary}55` as never,
    },
    suggestionChipText: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.primary,
    },
    taglineInputWrap: {
      borderRadius: 14,
      borderWidth: 1,
      borderColor: theme.gray[200],
      backgroundColor: theme.background.primary,
      paddingHorizontal: 14,
      paddingTop: 12,
      paddingBottom: 10,
    },
    taglineInput: {
      fontSize: 13,
      color: theme.gray[900],
      minHeight: 80,
      textAlignVertical: 'top',
    },
    taglineCharCount: {
      fontSize: 10,
      fontWeight: '700',
      color: theme.gray[400],
      textAlign: 'right',
      marginTop: 4,
    },
  });

export type CreateWorldCupGroupStep1FormStyles = ReturnType<typeof getCreateWorldCupGroupStep1FormStyles>;
